import React from 'react';

export class ProgramTabContainer extends React.Component {
  constructor( props ) {
    super( props );
    this.state = {
      width:  this.props.width === undefined ? 100 : parseInt( this.props.width, 10 ),
      height:  this.props.height === undefined ? 100 : parseInt( this.props.height, 10 ),
      activekey: props.activekey === undefined ? 0 : parseInt( props.activekey, 10 ),
      content: '',
      hasError: false,
      error: {},
      info: {}
    };

    // Bindings
    this.onSelectTab = this.onSelectTab.bind( this );
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  componentWillReceiveProps( nextProps ) {
    this.setState( {
      width:  nextProps.width === undefined ? 100 : parseInt( nextProps.width, 10 ),
      height:  nextProps.height === undefined ? 100 : parseInt( nextProps.height, 10 ),
      activekey: nextProps.activekey === undefined ? 0 : parseInt( nextProps.activekey, 10 )
    } );
  }

  onSelectTab( key, content ) {
    if( this.props.onSelectTab !== undefined ){
      this.props.onSelectTab( key, content );
    } else {
      this.setState( {
        activekey: key,
        content: content,
      } );
    }
  }

  render( ) {
    
    if( this.state.hasError === false ) {
      const width = this.state.width;
      const height = this.state.height;
      const styleWidth = width.toString() + '%';
      const styleHeight = height.toString() + '%';
      const activekey = this.state.activekey;
      let content = this.state.content;

      const tab_container_styles = {
        width: styleWidth,
        height: styleHeight,
      };

      let children = this.props.children;
      let boundChildren = [];
      if( children ) {
        if( children.constructor === Object ) {
          if( content === '' ){
            const tabs = children.props.children;
            if( tabs !== undefined ) {
              for( var tabindex = 0; tabindex < tabs.length; tabindex++ ) {
                const tab = tabs[ tabindex ];
                if( tabindex === activekey ) {
                  content = tab.props.children;
                }
              }
            }
          }
          children = React.cloneElement( this.props.children, {
            key: 'tab-panel-1',
            activekey: this.state.activekey,
            onSelectTab: this.onSelectTab,
          } );
          boundChildren.push( children );
        }
      }
      
      return (
        <div className="tab-container" style={tab_container_styles}>
          {boundChildren}
          <div className="tab-content">
            <div className="tab-content-inner">
              {content}
            </div>
          </div>
        </div>
      );
    } else {
      return ( <span></span> );
    }
  }
}

export class ProgramTabPanel extends React.Component {

  constructor( props ) {
    super( props );
    this.state = {
      caption: this.props.caption,
      showOnKey: this.props.showOnKey,
      currentKey: 0,
      hasError: false,
      error: {},
      info: {}
    };

    // Bindings
    this.onSelectTab = this.onSelectTab.bind( this );
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  onSelectTab( key, children ) {
    if( this.props.onSelectTab !== undefined ) {
      this.props.onSelectTab( key, children );
    }

    // Set the parent's current key tab
    this.setState( {
      currentKey: key
    } );
  }

  render( ) {

    if( this.state.hasError === false ) {

      let children = this.props.children;
      let boundChildren = [];

      if( children ) {
        if( children.constructor === Array ) {
          boundChildren = children.map( ( child, index ) => {
            const active = this.props.activekey === index ? true : false;
            const newchild = React.cloneElement( child, {
              key: 'tab-panel-item-' + index.toString(),
              eventKey: index,
              onSelectTab: this.onSelectTab,
              active: active,
            } );
            const isChildVisible = child.props.visible === undefined ? true : child.props.visible;
            if( isChildVisible === true ) {
              return( newchild );
            } else {
              return '';
            }
          } );
        }
        if( children.constructor === Object ) {
          const newchild = React.cloneElement( children, {
            key: 'tab-panel-item-1',
            eventKey: 1,
            onSelectTab: this.onSelectTab,
          } );
          boundChildren.push( newchild );
        }
      }

      return (
        <ul className="tab-panel">
          {boundChildren}
        </ul>
      );
    } else {
      return ( <span></span> );
    }
  }
}

export class ProgramTabPanelItem extends React.Component {
  constructor( props ){
    super( props );
    this.state = {
      caption: this.props.caption === undefined ? 'Tab' : this.props.caption,
      width: this.props.width === undefined ? '85px' : this.props.width,
      visible: this.props.visible === undefined ? true : this.props.visible,
      active: this.props.active === undefined ? false : this.props.active,
      hasError: false,
      error: {},
      info: {}
    };
    this.onSelectTab = this.onSelectTab.bind( this );
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  componentWillReceiveProps( nextProps ) {
    this.setState( {
      caption: nextProps.caption === undefined ? 'Tab' : nextProps.caption,
      width: nextProps.width === undefined ? '85px' : nextProps.width,
      visible: nextProps.visible === undefined ? true : nextProps.visible,
      active: nextProps.active === undefined ? false : nextProps.active,
    } );
  }

  onSelectTab( e ) {
    if( this.props.onSelectTab !== undefined ) {
      this.props.onSelectTab( this.props.eventKey, this.props.children );
    }
  }

  render( ) {

    if( this.state.hasError === false ) {
      const className = this.props.active === true ? 'tab-panel-item-active' : 'tab-panel-item';
      const width = this.state.width;
      let tab_panel_item_styles = {
        width: width
      };

      if( this.state.visible === true ) {
        return (
          <li className={className} style={tab_panel_item_styles} onClick={this.onSelectTab}>
            {this.state.caption}
          </li>
        );
      } else {
        return (
          <li></li>
        );
      }
    } else {
      return ( <span></span> );
    }
  }
}


// WEBPACK FOOTER //
// ./src/presentation/ProgramTabContainer.js